import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-time-taken-pie',
  templateUrl: './time-taken-info-pie.component.html',
  styleUrls: ['./time-taken-info-pie.component.scss'],
  standalone: false,
})
export class TimeTakenPieComponent implements OnInit, OnChanges {
  @Input() runHours!: string | number;
  @Input() shutDownHours!: string | number;
  @Input() isResponseOk = false;
  @Input() timetakenChartLoaded = false;
  @Input() isErrorResponse = false;
  timeTakenPie: any;
  timeTakenInfo: any[] = [];

  ngOnInit(): void {
    if (this.runHours && this.shutDownHours) {
      this.loadUsagePieChart();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
     if (this.runHours && this.shutDownHours) {
       this.loadUsagePieChart();
     } else {
      if(!this.isResponseOk && !this.isErrorResponse && this.timetakenChartLoaded){
          this.timetakenChartLoaded = false;
      }
     }
  }

  loadUsagePieChart(): void {
    if (this.runHours)
      this.runHours = this.normalizeToTimeString(this.runHours);
    if (this.shutDownHours)
      this.shutDownHours = this.normalizeToTimeString(this.shutDownHours);
    const runHoursNum = this.timeStringToHours(this.runHours);
    const shutdownHoursNum = this.timeStringToHours(this.shutDownHours);
    const timeTakendata = [
      { value: runHoursNum, name: 'Run Hours' },
      { value: shutdownHoursNum, name: 'Shutdown Hours' },
    ];
    this.timeTakenInfo = [
      {
        label: 'Run Hours',
        value: this.runHours,
        color: 'var(--new-temenos-cyan)',
      },
      {
        label: 'Shutdown Hours',
        value: this.shutDownHours,
        color: 'var(--new-temenos-accent-1)',
      },
    ];
    const timeTakenColorCodes = [
      this.getCssVar('--new-temenos-cyan'),
      this.getCssVar('--new-temenos-accent-1'),
    ];
    this.timeTakenPie = {
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
          const formatted = this.hoursToTimeString(params.value);
          return `${params.name}: ${formatted}`;
        },
      },
      series: [
        {
          type: 'pie',
          radius: ['80%', '100%'],
          avoidLabelOverlap: false,
          top: 20,
          bottom: 10,
          right: 10,
          left: 10,
          label: {
            show: false,
            position: 'bottom',
            formatter: '',
            fontSize: '20',
          },
          labelLine: {
            show: false,
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 0,
          },
          color: timeTakenColorCodes,
          data: timeTakendata,
        },
      ],
    };
    this.timetakenChartLoaded = true;
  }

  getCssVar(variable) {
    return getComputedStyle(document.documentElement)
      .getPropertyValue(variable)
      .trim();
  }

  normalizeToTimeString(value: string | number): string {
    if (typeof value === 'number') value = value.toString();
    const timeParts = value.split(':');
    if (timeParts.length === 3) {
      const [h, m, s] = timeParts.map((part) => part.padStart(2, '0'));
      return `${h}:${m}:${s}`;
    }
    const hours = parseInt(value, 10);
    if (!isNaN(hours)) {
      return `${hours.toString().padStart(2, '0')}:00:00`;
    }
    return '00:00:00';
  }

  timeStringToHours(time: string | number): number {
    if (typeof time === 'number') return time;
    const parts = time.split(':').map(Number);
    if (parts.length === 3) {
      const [h, m, s] = parts;
      return +(h + m / 60 + s / 3600).toFixed(2);
    }
    return parseFloat(time) || 0;
  }
  hoursToTimeString(hours: number): string {
    const h = Math.floor(hours);
    const m = Math.floor((hours - h) * 60);
    const s = Math.round(((hours - h) * 60 - m) * 60);
    const pad = (num: number) => String(num).padStart(2, '0');
    return `${h.toString().padStart(2, '0')}:${pad(m)}:${pad(s)}`;
  }
}
